import {remCalc} from '_themeUtils'

const storiesGrid = {
    StoriesGrid: {
        baseStyle: () => ({
            grid: {
                columns: {base: 1, xl: 2},
                rowGap: 'spacing.8',
                columnGap: 'spacing.8',
                maxWidth: remCalc(1950),
                mx: 'auto',
                pt: 'spacing.2',
                pb: 'spacing.22',
                px: {base: 'spacing.4', xl: 'spacing.8'},
            },
            story: {
                gap: 'spacing.10',
            },
            findOutWrapper: {
                w: 'full',
                justifyContent: 'flex-end',
            },
            findOutLink: {
                textDecoration: 'underline',
                textTransform: 'uppercase',
                textStyle: 'paragraphSm',
                fontWeight: 500,
                letterSpacing: remCalc(3),
            },
        }),
    },
}

export default storiesGrid
